module.exports = __webpack_public_path__ + "static/media/res1.9c31b3fa.svg";